import { getGlobal } from "../../../global";
import { selectChat, selectUser, selectUserFullInfo } from "../../../global/selectors";
import useInfiniteScroll from "../../../hooks/useInfiniteScroll";
import React, { useState, FC, memo, useEffect, useRef, useMemo } from "../../../lib/teact/teact";
import buildClassName from "../../../util/buildClassName";
import MessageInput from "../../middle/composer/MessageInput";
import Button from "../../ui/Button";
import Checkbox from "../../ui/Checkbox";
import InfiniteScroll from "../../ui/InfiniteScroll";
import ListItem from "../../ui/ListItem";
import Modal from "../../ui/Modal";
import SearchInput from "../../ui/SearchInput";
import { LotMessage } from "../types/types";
import '../ui/formCommon.scss'
type OwnProps = {
    messages: LotMessage[]
    messageIndex: number;
    isOpen: boolean;
    onClose: () => void;
    onIndexChange: (newIndex: number) => void;
    onSearchChange: (filter: string) => void;
    onMessagesSelect: (messageSelected: string[]) => void;
    filter?: string;

}

const TeleMessages: FC<OwnProps> = ({
    messages,
    messageIndex,
    isOpen,
    onClose,
    onIndexChange,
    onSearchChange,
    onMessagesSelect,
    filter,
}) => {
    const refSearch = useRef()
    const [state, setState] = useState({
        isOpen: isOpen,
        selectedMessgas: [""]
    })
    const global = getGlobal()
    const messageLength = messages.length
    useEffect(() => {
        if (isOpen) {
            let element = document.getElementById("message:" + messageIndex)
            if (element) {

                // element.scrollIntoView({
                //     behavior: "auto",
                //     block: "start",
                //     inline: "nearest"
                // })
                element.scrollIntoView(true)
                const time = setTimeout(() => {
                    element!.scrollTop -= 100
                    clearTimeout(time)
                }, 100)

            }
        }
    }, [messageIndex, isOpen])
    const buildListIds = useMemo(() => {
        const ids: string[] = []
        for (let i = 0; i < messages.length; i++) {
            ids.push(i + "")
        }
        return ids
    }, [messages, messageIndex])
    function handleSelectMessages(id: string) {
        let tmp = state.selectedMessgas
        if (!state.selectedMessgas.includes(id))
            tmp.push(id)
        else
            tmp = state.selectedMessgas.filter(item => item != id)
        setState((prev: any) => ({ ...prev, selectedMessgas: tmp }))

    }
    const [viewportIds, getMore] = useInfiniteScroll(undefined, buildListIds, false, 60, messageIndex + "");
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            className={'confirm'}

        >
            <div className=" main-messages-list">
                <div className=" header-container">
                    <div className="header">
                        <Button round size="smaller"
                            onClick={() => {
                                onClose()
                            }}
                            color="translucent"
                        >
                            <i
                                className='icon icon-arrow-left'
                                aria-hidden
                            />
                        </Button>
                        <SearchInput
                            ref={refSearch}
                            value={filter}
                            inputId="telegram-search-input"
                            parentContainerClassName="LeftSearch"
                            onChange={(filter) => {
                                onSearchChange(filter)
                                refSearch?.current.focus()
                            }}></SearchInput>
                    </div>
                </div>
                {state.selectedMessgas.length > 1 && <div className=" common-container-row">
                    <div>Đã chọn {state.selectedMessgas.length - 1}</div>
                    <Button round size="smaller"
                        onClick={() => {
                            //onMessagesSelect(state.selectedMessgas)
                            //onClose()
                            setState((prev: any) => ({ ...prev, selectedMessgas: [""] }))
                        }}
                        color="translucent"
                    >
                        <i className="icon icon-remove"></i>
                    </Button>
                    <Button round size="smaller"
                        onClick={() => {
                            onMessagesSelect(state.selectedMessgas)
                            onClose()
                            setState((prev: any) => ({ ...prev, selectedMessgas: [""] }))
                        }}
                        color="translucent"
                    >
                        <i className="fa-solid fa-circle-check"></i>
                    </Button>
                </div>}
                <div className=" data">
                    <InfiniteScroll
                        style="height:calc(100vh - calc(var(--header-height)) * 5)"
                        items={viewportIds}
                        onLoadMore={getMore}
                        className="chat-list custom-scroll"
                    // currentAnchor={currentAnchor}
                    //ref={containerRef}
                    >
                        {
                            viewportIds && viewportIds.map((id: number, index: number) => {
                                const item: any = messages[id]
                                const chat = selectChat(global, item.tlChatId)
                                //const user=selectUser(global,item.tlSenderId)
                                // let displayName =(user?.firstName!=undefined?user?.firstName:"")+" "
                                //  displayName +=user?.lastName!=undefined?user?.lastName:""
                                let displayName = chat?.title
                                return (
                                    <ListItem id={"message:" + id} key={"msg:" + id}>

                                        <div className="message-container" id={"message:" + id}
                                            onClick={(e) => {
                                                //onIndexChange(Number(id))
                                                //e.preventDefault()
                                                //onClose()
                                                handleSelectMessages(id)
                                            }}>
                                            <Checkbox key={"check" + id} label="" checked={state.selectedMessgas.includes(id + "")}></Checkbox>
                                            <div className="chat-info">
                                                {Number(id) + 1}/{messageLength}{" "}
                                                {displayName}
                                            </div>
                                            <div className=" message-item">
                                                {item.body}
                                            </div>
                                        </div>

                                    </ListItem>
                                )
                            })
                        }
                    </InfiniteScroll>
                </div>

            </div>

        </Modal>
    )
}
export default memo(TeleMessages)